import { enableMapSet } from 'immer';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { IMatchTypeStore } from './store.types';

enableMapSet();

export const useMatchTypesStore = create<IMatchTypeStore>()(immer((set) => ({
  map: new Map(),
  addMatchTypes(payload) {
    payload.forEach(el => {
      set(state => {
        state.map.set(el.id, el);
      });
    });
  },
  clearMap() {
    set(state => {
      state.map.clear();
    });
  },
})));
